<template>
  <ThePage :tab-title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>
    <template #pageContent>
      <NavTabs
        :index-route-name="ROUTE_NAMES.OPPORTUNITIES.INDEX"
        :label="translations.tabsBarLabel"
        :should-show-label
      />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { ROUTE_NAMES } from '~/constants/routes'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import translations from './Opportunities.translations'

const i18n = useI18n()
const businessFeaturesStore = useBusinessFeaturesStore()

function shouldShowLabel(routeName: string): boolean {
  if (
    ROUTE_NAMES.OPPORTUNITIES.INVENTORY === routeName &&
    !businessFeaturesStore.isFeatureEnabled('inventoryOpportunityEnabled')
  ) {
    return false
  }

  return true
}
</script>
